export default __webpack_public_path__ + "static/media/icon-edit.3cd1ab7c.svg";